<aw-table
  *ngIf="showTable && config.tableVersion !== 2"
  [data]="data"
  [config]="config"
  (select)="onSelect($event)"
  (click)="click($event)"
></aw-table>
<aw-table-2
  *ngIf="showTable && config.tableVersion === 2"
  [config]="config.tableConfig"
  [request]="config.request"
  (rowClick)="click($event)"
  (rowSelect)="onSelect($event)"
></aw-table-2>
